module.exports = __webpack_public_path__ + "img/agenda.ff04d33e.svg";